/**
 * Map of country codes to country names
 */
export const COUNTRY_NAMES = {
  'US': 'United States',
  'FR': 'France',
  'DE': 'Germany',
  'IT': 'Italy',
  'ES': 'Spain',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'PT': 'Portugal',
  'AT': 'Austria',
  'IE': 'Ireland',
  'FI': 'Finland',
  'GR': 'Greece',
  'GB': 'United Kingdom',
  'UK': 'United Kingdom',
  'CA': 'Canada',
  'JP': 'Japan',
  'CN': 'China',
  'AU': 'Australia',
  'NZ': 'New Zealand',
  'CH': 'Switzerland',
  'SE': 'Sweden',
  'DK': 'Denmark',
  'NO': 'Norway',
  'IN': 'India',
  'RU': 'Russia',
  'BR': 'Brazil',
  'ZA': 'South Africa',
  'KR': 'South Korea',
  'SG': 'Singapore',
  'HK': 'Hong Kong',
};

/**
 * Get country name from country code
 * @param {string} countryCode - The ISO 3166-1 alpha-2 country code
 * @returns {string} - The country name or 'Unknown Country' if not found
 */
export const getCountryName = (countryCode) => {
  return COUNTRY_NAMES[countryCode] || 'Unknown Country';
};

/**
 * List of supported countries for Stripe Connect
 * This is a subset of all countries - can be extended as needed
 */
export const SUPPORTED_COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'FR', name: 'France' },
  { code: 'DE', name: 'Germany' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  // Add more supported countries as needed
];

/**
 * Map of country codes to ISO 4217 currency codes
 */
export const COUNTRY_TO_CURRENCY = {
  'US': 'USD',
  'FR': 'EUR',
  'DE': 'EUR',
  'IT': 'EUR',
  'ES': 'EUR',
  'NL': 'EUR',
  'BE': 'EUR',
  'PT': 'EUR',
  'AT': 'EUR',
  'IE': 'EUR',
  'FI': 'EUR',
  'GR': 'EUR',
  'GB': 'GBP',
  'UK': 'GBP', // Alias for United Kingdom
  'CA': 'CAD',
  'JP': 'JPY',
  'CN': 'CNY',
  'AU': 'AUD',
  'NZ': 'NZD',
  'CH': 'CHF',
  'SE': 'SEK',
  'DK': 'DKK',
  'NO': 'NOK',
  'IN': 'INR',
  'BR': 'BRL',
  'RU': 'RUB',
  'ZA': 'ZAR',
  'KR': 'KRW',
  'SG': 'SGD',
  'HK': 'HKD',
  // Add more mappings as needed
};

/**
 * Get currency code from country code
 * @param {string} countryCode - The ISO 3166-1 alpha-2 country code
 * @returns {string} - The ISO 4217 currency code or 'USD' if not found or invalid
 */
export const getCurrencyFromCountryCode = (countryCode) => {
  if (countryCode && COUNTRY_TO_CURRENCY[countryCode.toUpperCase()]) {
    return COUNTRY_TO_CURRENCY[countryCode.toUpperCase()];
  }
  return 'USD'; // Default to USD if country code is not found or invalid
}; 